import get from 'lodash.get';
import isEmpty from 'lodash.isempty';
import ScoreInterpretationMapper from '../../constants/shared/ScoreInterpretationMapper';
import { getInterpSortIndex, getScoreSortIndex } from '../shared/sortUtils';
import { TRC_OR_TRO, MEASURE } from '../../constants/reading/MeasuresConstants';
import { GATING } from '../../constants/shared/CommonConstants';

const NOT_SCORED_SORT_INDEX = -3;
const TESTED_OUT_SORT_INDEX = 1000;

/**
 * Calculating sorting index based on `interpretation` value
 */
export const getD8InterpSortIndex = (measure, statusForMeasureYearPeriod, isMeasureAvailable) => {
    const isUntranscribable = get(statusForMeasureYearPeriod, 'isUntranscribable', false);
    const gatingType = get(statusForMeasureYearPeriod, 'gatingType', null);

    let interpSortIndex = getInterpSortIndex(
        measure,
        statusForMeasureYearPeriod,
        isMeasureAvailable,
        TRC_OR_TRO,
        gatingType,
    );

    if (isUntranscribable) {
        interpSortIndex = NOT_SCORED_SORT_INDEX;
    }

    if (!isEmpty(statusForMeasureYearPeriod)) {
        const { interp } = statusForMeasureYearPeriod;

        if (interp && measure === MEASURE.RAN) {
            const interpKeys = Object.keys(ScoreInterpretationMapper);
            interpSortIndex = interpKeys.length - interpKeys.indexOf(interp);
        }
    }

    return interpSortIndex;
};

const getReadingScoreIndex = (measure, statusForMeasureYearPeriod) => {
    if (measure === MEASURE.LEXILE) return get(statusForMeasureYearPeriod, 'compositeScore');

    return getScoreSortIndex(measure, statusForMeasureYearPeriod);
};

/**
 * Calculating sorting index based on `score` value
 */
export const getD8ScoreSortIndex = (measure, statusForMeasureYearPeriod) => {
    let scoreSortIndex = getReadingScoreIndex(measure, statusForMeasureYearPeriod);
    const gatingType = get(statusForMeasureYearPeriod, 'gatingType', null);

    if (gatingType === GATING.TESTED_OUT) {
        scoreSortIndex = TESTED_OUT_SORT_INDEX;
    }

    return scoreSortIndex;
};
